const messages = {
    NO_APPROVER: 'Approval person not found, please recheck at DOA Book below.'
}

export default messages;